import { request } from '../utils/http'

const extractUploadUrl = (item) => {
  if (!item) return ''
  if (typeof item === 'string') return item
  if (typeof item === 'object') return item.url || item.fileUrl || item.path || ''
  return ''
}

const normalizeUploadUrls = (payload) => {
  if (Array.isArray(payload)) {
    return payload.map(extractUploadUrl).filter(Boolean)
  }

  const singleUrl = extractUploadUrl(payload)
  return singleUrl ? [singleUrl] : []
}

export const getStoryPage = ({ pageNum = 1, pageSize = 10 } = {}) => request(`/api/story/page?pageNum=${pageNum}&pageSize=${pageSize}`)

export const getStoryDetail = (id) => request(`/api/story/${id}`)

export const createStory = (payload) => request('/api/story', {
  method: 'POST',
  body: payload
})

export const updateStory = (id, payload) => request(`/api/story/${id}`, {
  method: 'PUT',
  body: payload
})

export const deleteStory = (id) => request(`/api/story/${id}`, {
  method: 'DELETE'
})

export const createStoryComment = (payload) => request('/api/story/comment', {
  method: 'POST',
  body: payload
})

export const deleteStoryComment = (id) => request(`/api/story/comment/${id}`, {
  method: 'DELETE'
})

export const getTodayInHistory = () => request('/api/story/today-in-history')

export const getVisitorStories = ({ pageNum = 1, pageSize = 10 } = {}) => request(`/api/visitor/stories?pageNum=${pageNum}&pageSize=${pageSize}`)

export const getVisitorStoryDetail = (id) => request(`/api/visitor/story/${id}`)

export const uploadStoryFile = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request('/api/upload/file', {
    method: 'POST',
    body: formData
  }).then((payload) => normalizeUploadUrls(payload)[0] || '')
}

export const uploadStoryFiles = (files) => {
  const formData = new FormData()
  Array.from(files || []).forEach((file) => formData.append('files', file))
  return request('/api/upload/files', {
    method: 'POST',
    body: formData
  }).then((payload) => normalizeUploadUrls(payload))
}
